import { OrderProps, RangeOptions, SelectDefaultValue } from '../../../../domain'

export const percentageDataToOrderBy: RangeOptions[] = [
  { id: 1, value: 0, key: 'lessThanFiveHundred', range: '<500' },
  { id: 2, value: 0, key: 'betweenFiveHundredAndSixHundred', range: '500 - 600' },
  { id: 3, value: 0, key: 'betweenSixHundredAndSevenHundred', range: '600 - 700' },
  { id: 4, value: 0, key: 'betweenSevenHundredAndEightHundred', range: '700 - 800' },
  { id: 5, value: 0, key: 'betweenEightHundredAndNineHundred', range: '800 - 900' },
  { id: 6, value: 0, key: 'betweenNineHundredAndThousand', range: '900 - 1.000' },
  { id: 7, value: 0, key: 'greaterThanThousand', range: '>1.000' }
]

interface OrderOptions {
  id: number
  title: string
  order: OrderProps
}
export const percentageOrderOptions: OrderOptions[] = [
  { id: 1, title: 'Menor para o Maior (Range)', order: { by: 'id', type: 'asc' } },
  { id: 2, title: 'Maior para o Menor (Range)', order: { by: 'id', type: 'desc' } },
  { id: 3, title: 'Menor para o Maior (Qtd)', order: { by: 'value', type: 'asc' } },
  { id: 4, title: 'Maior para o Menor (Qtd)', order: { by: 'value', type: 'desc' } }
]

export const orgsOrderOptions: OrderOptions[] = [
  { id: 1, title: 'Menor para o Maior', order: { by: 'response', type: 'asc' } },
  { id: 2, title: 'Maior para o Menor', order: { by: 'response', type: 'desc' } },
  { id: 3, title: 'Ordem alfabética', order: { by: 'serverName', type: 'asc' } }
]

export const percentageOrderDefault = (): SelectDefaultValue => ({
  label: percentageOrderOptions[0].title,
  value: percentageOrderOptions[0].order
})

export const orgsOrderDefault = (): SelectDefaultValue => ({
  label: orgsOrderOptions[orgsOrderOptions.length - 1].title,
  value: orgsOrderOptions[orgsOrderOptions.length - 1].order
})
